export const CheckCircleSolidIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        >
        <circle cx="12.9668" cy="12.9276" r="12" fill="white" />
        <path
            d="M8.35645 13.5651L11.5064 16.7151L18.3314 9.89014"
            stroke="#714FAA"
            stroke-width="2"
            stroke-linecap="round"
        />
        </svg>
    `,
      }}
    />
  );
};
